import { FC } from 'react';
import { Tag } from 'antd';
import { mapTagsToLabels } from 'utils/sensorTags';
import './styles.scss';

interface TagListProps {
  tagList: string[];
}

const TagList: FC<TagListProps> = ({ tagList }) => {
  const parsedTags = mapTagsToLabels(tagList);

  return (
    <div className='TagList__wrapper'>
      {!!parsedTags.length && parsedTags.map((tag) => (
        <Tag key={tag.value} className={'TagList__tag'}>
          {tag.label}
        </Tag>
      ))}
    </div>
  )
};

export default TagList;